import type { WatershedData } from '../../types';

interface Props {
  watershed: WatershedData | null;
}

export default function WatershedPanel({ watershed }: Props) {
  if (!watershed) {
    return (
      <div className="panel">
        <div className="panel-title">Watershed</div>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>
          Watershed data unavailable for this location.
        </p>
      </div>
    );
  }

  const { properties: p } = watershed;

  return (
    <div className="panel">
      <div className="panel-title">Watershed Characteristics</div>

      <div className="data-row">
        <span className="data-label">Drainage Area</span>
        <span className="data-value">{p.area_sq_mi.toFixed(2)} mi²</span>
      </div>

      <div className="data-row">
        <span className="data-label">Perimeter</span>
        <span className="data-value">{p.perimeter_mi.toFixed(2)} mi</span>
      </div>

      <div className="data-row">
        <span className="data-label">Mean Elevation</span>
        <span className="data-value">{p.mean_elevation_ft.toLocaleString()} ft</span>
      </div>

      <div className="data-row">
        <span className="data-label">Elevation Range</span>
        <span className="data-value">
          {p.min_elevation_ft.toLocaleString()} – {p.max_elevation_ft.toLocaleString()} ft
        </span>
      </div>

      <div className="data-row">
        <span className="data-label">Mean Slope</span>
        <span className="data-value">{p.mean_slope_pct.toFixed(1)}%</span>
      </div>

      <div className="data-row">
        <span className="data-label">Longest Flow Path</span>
        <span className="data-value">{p.longest_flow_path_mi.toFixed(2)} mi</span>
      </div>
    </div>
  );
}
